import React, { useEffect, useState } from "react";
import { useDoubleClick } from "@zattoo/use-double-click";
import { Input } from "../ui/input";
import Button from "./button";

interface EditableFieldProps {
    value: string;
    onChange: (value: string) => void;
}

export default function EditableField({ value, onChange }: EditableFieldProps) {
    const [isEdit, setIsEdit] = useState(false);
    const [newValue, setNewValue] = useState(value);
    const hybridClick = useDoubleClick(
        () => setIsEdit(!isEdit),
        () => {}
    );

    function updateValue() {
        onChange(newValue);
        setIsEdit(false);
    }

    function keyDown(e: React.KeyboardEvent<HTMLInputElement>) {
        if (e.key === "Escape") {
            setIsEdit(false);
            return;
        }

        if (e.key === "Enter") {
            updateValue();
            return;
        }
    }

    useEffect(() => {
        setNewValue(value);
    }, [value]);

    if (!isEdit) return <button onClick={hybridClick}>{value}</button>;
    return (
        <div className="flex w-full items-center gap-2">
            <Input autoFocus onKeyDown={(e) => keyDown(e)} value={newValue} onChange={(e) => setNewValue(e.target.value)}></Input>
            <Button onClick={updateValue}>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={4} stroke="currentColor" className="h-3 w-3">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                </svg>
            </Button>
        </div>
    );
}
